/**
 * Editor-only styling for the personalization components. It is injected as
 * `canvasCss`, so it never becomes part of the stored page CSS.
 */
export default `
[data-novti-var] {
  display: inline-block;
  margin: 0 .1em;
  padding: 0 .55em;
  border-radius: 999px;
  background: rgba(99, 102, 241, .12);
  box-shadow: inset 0 0 0 1px rgba(99, 102, 241, .28);
  color: #4f46e5;
  font: 600 .78em/1.7 system-ui, -apple-system, "Segoe UI", sans-serif;
  letter-spacing: .01em;
  white-space: nowrap;
  vertical-align: baseline;
  cursor: default;
  user-select: none;
}
[data-novti-var]::before { content: attr(data-novti-var); }
[data-novti-var='']::before { content: '\\2026'; opacity: .6; }
[data-novti-var][data-novti-fallback]:not([data-novti-fallback=''])::after {
  content: '\\00a0\\00b7\\00a0' attr(data-novti-fallback);
  font-weight: 400;
  opacity: .65;
}

[data-novti-cond] {
  position: relative;
  margin: 6px 0;
  padding: 0 0 0 12px;
  border-left: 2px solid rgba(217, 119, 6, .4);
  transition: border-color .15s, background-color .15s;
}
[data-novti-cond]:hover,
[data-novti-cond].gjs-selected {
  border-left-color: #d97706;
  background-color: rgba(217, 119, 6, .04);
}
[data-novti-cond]::before {
  content: attr(data-novti-cond-label);
  display: block;
  width: fit-content;
  max-width: 100%;
  margin: 0 0 4px;
  padding: 1px 8px;
  border-radius: 999px;
  background: rgba(217, 119, 6, .12);
  color: #b45309;
  font: 600 11px/1.6 system-ui, -apple-system, "Segoe UI", sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

[data-novti-lane] { min-height: 28px; }
[data-novti-lane]:empty {
  outline: 1px dashed rgba(217, 119, 6, .35);
  outline-offset: -1px;
  border-radius: 4px;
}
[data-novti-lane]:empty::after {
  content: attr(data-novti-lane-hint);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  color: rgba(180, 83, 9, .6);
  font: 12px system-ui, -apple-system, "Segoe UI", sans-serif;
}

[data-novti-lane='else'] {
  display: none;
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px dashed rgba(217, 119, 6, .4);
}
[data-novti-cond][data-novti-cond-else] > [data-novti-lane='else'] { display: block; }
[data-novti-lane='else']::before {
  content: attr(data-novti-lane-label);
  display: block;
  width: fit-content;
  margin: 0 0 4px;
  padding: 1px 8px;
  border-radius: 999px;
  box-shadow: inset 0 0 0 1px rgba(217, 119, 6, .35);
  color: #b45309;
  font: 600 11px/1.6 system-ui, -apple-system, "Segoe UI", sans-serif;
}
`
